(() => {
  class TwSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-tw-slider-track]');
      this.prev = this.querySelector('[data-tw-slider-prev]');
      this.next = this.querySelector('[data-tw-slider-next]');
      if (!this.track) return;

      this.onPrev = () => this.scroll(-1);
      this.onNext = () => this.scroll(1);
      this.onScroll = () => this.updateControls();

      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.track);
      this.updateControls();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    scroll(direction) {
      if (!this.track) return;
      const firstItem = this.track.firstElementChild;
      const amount = firstItem?.getBoundingClientRect().width || this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: direction * (amount + gap),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    updateControls() {
      if (!this.track) return;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const current = Math.abs(this.track.scrollLeft);
      if (this.prev) this.prev.disabled = current <= 1;
      if (this.next) this.next.disabled = current >= max - 1;
    }
  }

  if (!customElements.get('tw-slider')) {
    customElements.define('tw-slider', TwSlider);
  }
})();
